import { render, staticRenderFns } from "./signRule.vue?vue&type=template&id=5a0a545a&scoped=true"
import script from "./signRule.vue?vue&type=script&lang=js"
export * from "./signRule.vue?vue&type=script&lang=js"
import style0 from "./signRule.vue?vue&type=style&index=0&id=5a0a545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a545a",
  null
  
)

export default component.exports